<template>
  <div class="container-main">
    <!-- <bannerVideo
      bg="#c1bbaa"
      :vwClass="true"
      title="彼芯学习机"
      :allVideoUrl="video"
      :message="messageInfo"
      videoUrl="https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/xuexiji_info.mp4"
    >
    </bannerVideo> -->
    <outboxCon>
      <div class="teach-quality">
        <ul class="teach-quality-ul">
          <li v-for="(item, i) in imgConfig" :key="i">
            <img class="icon-quality" :src="item.imgUrl" :alt="item.desc" />
          </li>
        </ul>
      </div>
    </outboxCon>
  </div>
</template>
<script>
import bannerVideo from './components/bannerVideo/bannerVideo'
export default {
  data () {
    return {
      video: 'https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/videos/xuexiji_info.mp4',
      imgConfig: [
        {
          desc: '',
          imgUrl: require('@/assets/coursetype/xuexiji/scene-1.png')
        },
        {
          desc: '',
          imgUrl: require('@/assets/coursetype/xuexiji/scene-2.png')
        },
        {
          desc: '',
          imgUrl: require('@/assets/coursetype/xuexiji/scene-3.png')
        },
        {
          desc: '',
          imgUrl: require('@/assets/coursetype/xuexiji/scene-4.png')
        },
        {
          desc: '',
          imgUrl: require('@/assets/coursetype/xuexiji/scene-5.png')
        },
        {
          desc: '',
          imgUrl: require('@/assets/coursetype/xuexiji/scene-6.png')
        }
      ],
      messageInfo: `彼芯学习机是由好未来美校&魔法校联合打造的适合一年级~高三全学龄学生的智能学习机。使用华为C5平板作为系统载体，由好未来教研云核心团队提供课程内容，搭载了测评、拍搜、课本点读等智能学习工具。`
    }
  },
  components: { bannerVideo }
}
</script>

<style lang="scss" scoped>
.teach-quality {
  margin: 0 auto;
  width: $main-width;
  display: flex;
  justify-content: center;
  padding: 80px 0px 60px 0px;
  .teach-quality-ul {
    .icon-quality {
      width: 100%;
      height: 100%;
      display: block;
      max-width: 1034px;
      margin: 0 auto;
    }
  }
}
</style>
